import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CommentsSection from 'components/Comments/CommentsSection'
import SolutionIssues from 'components/Solutions/SolutionProfile/SolutionIssues'
import MeetingsSection from 'components/Meetings/MeetingsSection'
import { Solution } from 'util/constants'
import ScrollableTabsList from 'ui/ScrollableTabsList'
import ScrollHideContainer from 'ui/ScrollHideContainer'

interface Props {
  solution: Solution
}

const SolutionProfileTabs = ({ solution }: Props) => {
  const { id, tab } = useParams<{ id: string; tab?: string }>()
  const [selectedTab, setSelectedTab] = useState<string>(tab || 'comments')

  // Update selectedTab when URL tab parameter changes
  useEffect(() => {
    if (tab) {
      // Handle the mismatch between the route "events" and the value "meetings"
      if (tab === 'events') {
        setSelectedTab('meetings')
      } else {
        setSelectedTab(tab)
      }
    } else {
      setSelectedTab('comments')
    }
  }, [tab])

  //REMOVED: already have NavLink on scrollable tabs so this causes double navigation
  /*const handleTabChange = (newTab: string) => {
    setSelectedTab(newTab)
    navigate(`/solution/${id}/${newTab}`)
  }*/

  const tabsData = [
    {
      label: 'Comments',
      route: `/solution/${id}/comments`,
      value: 'comments',
    },
    {
      label: 'Issues',
      route: `/solution/${id}/issues`,
      value: 'issues',
    },
    {
      label: 'Events',
      route: `/solution/${id}/events`,
      value: 'meetings',
    },
  ]

  return (
    <div className="py-0 relative">
      <ScrollHideContainer 
        className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
        hideOffset={57}
        threshold={56}
      >
      <div className="p-2">
        <ScrollableTabsList
          key={`solution-${id}-tabs`}
          tabs={tabsData}
          selectedTab={selectedTab}
          onTabChange={() => {}}
          pageTitle={`Solution - ${solution.name}`}
          />
        </div>
      </ScrollHideContainer>
      <div className="py-0 relative">
        {(selectedTab === 'comments' || !tab) && (
          <CommentsSection
            commentable_id={solution.id}
            commentable_type="solution"
            isEntitySection={true}
          />
        )}
        {selectedTab === 'issues' && (
          <SolutionIssues solutionId={solution.id} />
        )}
        {selectedTab === 'meetings' && (
          <MeetingsSection
            entity={solution}
            entityType="solution"
            sort="soonest"
          />
        )}
      </div>
    </div>
  )
}

export default SolutionProfileTabs
